(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,3653],{

/***/ 26518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ContentfulContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/** @public */
var ContentfulContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/** @public */
var ContentfulProvider = function (_a) {
    var contentful = _a.contentful, children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentfulContext.Provider, { value: contentful }, children);
};
ContentfulProvider.displayName = 'ContentfulProvider';
ContentfulContext.displayName = 'ContentfulContext';
/* harmony default export */ __webpack_exports__["Z"] = (ContentfulProvider);
//# sourceMappingURL=ContentfulProvider.js.map

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(14602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27204);


var _obj;
var BANNER_TEXT_VALUES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_1__/* .FLIGHT_PRODUCT_TYPE */ .oP, {
    titleText: "Get the app. Save more.",
    contentText: "Save up to 40% on flights with the app",
    pageId: "MWEB_FLT_HP_HEADER"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_1__/* .HOME_PRODUCT_TYPE */ .Wn, {
    titleText: "Get the app. Save more.",
    contentText: "Get exclusive deals only in our app",
    pageId: "MWEB_HTL_HP_HEADER"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, _constants_products__WEBPACK_IMPORTED_MODULE_1__/* .HOTEL_PRODUCT_TYPE */ .kd, {
    titleText: "Get the app. Save more.",
    contentText: "Save up to 60% off hotels with the app",
    pageId: "MWEB_HTL_HP_HEADER"
}), _obj);
/* harmony default export */ __webpack_exports__["Z"] = (BANNER_TEXT_VALUES);


/***/ }),

/***/ 93653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AppBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/components/AppBanner/useAppBanner.ts
var useAppBanner = __webpack_require__(7598);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(39997);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
;// CONCATENATED MODULE: ./src/components/AppBanner/useAppBannerForIosSafari.ts

function useAppBannerForIosSafari(referral, clientGUID) {
    var ref = (0,react.useState)(""), userAgent = ref[0], setUserAgent = ref[1];
    (0,react.useEffect)(function() {
        var UA = navigator.userAgent;
        setUserAgent(UA);
    }, []);
    var isIphone = userAgent.match(/iPhone/i);
    var webkit = !!userAgent.match(/WebKit/i);
    var iOSSafari = isIphone && webkit && !userAgent.match(/CriOS/i);
    var ref1, ref2, ref3;
    var impressionUrl = [
        "https://imp.control.kochava.com/track/impression?campaign_id=koiospriceline388053593d51c5580c1da575ac62c7&network_id=1017",
        "&PAGEID=IOS_SMARTBANNER",
        "&REFID=".concat((ref1 = referral === null || referral === void 0 ? void 0 : referral.sourceId) !== null && ref1 !== void 0 ? ref1 : "").concat((ref2 = referral === null || referral === void 0 ? void 0 : referral.id) !== null && ref2 !== void 0 ? ref2 : ""),
        "&REFCLICKID=".concat((ref3 = referral === null || referral === void 0 ? void 0 : referral.clickId) !== null && ref3 !== void 0 ? ref3 : ""),
        "&SUB_SITE_ID=".concat(clientGUID, "&site_id=1")
    ].join("");
    return [
        iOSSafari,
        impressionUrl
    ];
}

;// CONCATENATED MODULE: ./src/components/AppBanner/AppBanner.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 8px;\n  @media (min-width: 400px) {\n    padding-right: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  &:active,\n  &:focus,\n  &:visited,\n  &:hover {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var COOKIE_MAX_AGE = 2592000 // 30 Days
;
var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-177ce0a3-0"
})(_templateObject(), (0,utils/* getPaletteColor */.ow)("background.base"), (0,utils/* getPaletteColor */.ow)("text.lightest"));
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-177ce0a3-1"
})(_templateObject1(), (0,utils/* getPaletteColor */.ow)("text.lightest"));
var appIconUrl = "https://s1.pclncdn.com/design-assets/brand-assets/app-icon.svg";
function AppBanner(param) {
    var titleText = param.titleText, contentText = param.contentText, pageId = param.pageId, referral = param.referral, clientGUID = param.clientGUID;
    var ref = (0,react.useState)(true), isBannerVisible = ref[0], setBannerVisible = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(useAppBannerForIosSafari(referral, clientGUID), 2), iOSSafari = ref1[0], impressionUrl = ref1[1];
    var closeAppBanner = function() {
        setBannerVisible(false);
        document.cookie = "hideAppBanner=true; domain=.priceline.com; path=/; max-age=".concat(COOKIE_MAX_AGE, ";");
    };
    var ref2, ref3;
    var downloadAppLink = "https://www.priceline.com/r/app/?channel=Display&product=App&theme=app_dl_install    &PAGEID=".concat(pageId, "_v5    &sub_site_id=").concat(clientGUID, "    &refid=").concat((ref2 = referral === null || referral === void 0 ? void 0 : referral.id) !== null && ref2 !== void 0 ? ref2 : "", "    &refclickid=").concat((ref3 = referral === null || referral === void 0 ? void 0 : referral.clickId) !== null && ref3 !== void 0 ? ref3 : "", "\n  ");
    if (iOSSafari) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "apple-itunes-app",
                        content: "app-id=336381998"
                    }, "apple-smart-banner")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: impressionUrl,
                    height: "0",
                    width: "1",
                    border: "0"
                })
            ]
        });
    }
    return isBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        id: "app-download-banner",
        className: "app-banner",
        fontSize: 0,
        m: 1,
        borderRadius: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                mr: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                    style: {
                        color: "#0068ef"
                    },
                    size: 24,
                    id: "closeBannerBtn",
                    "data-ga-category": "PCLN_HOME",
                    "data-ga-action": "App_Banner",
                    "data-ga-label": "dismiss",
                    title: "dismiss app banner",
                    onClick: closeAppBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                color: "text.lightest",
                href: downloadAppLink,
                "data-testid": "DASH_MWEB_TAB_GET_APP",
                "data-ga-category": "PCLN_HOME",
                "data-ga-action": "App_Banner",
                "data-ga-label": "click to launch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "flex-start",
                        pr: 12,
                        py: 0,
                        width: 52,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: appIconUrl,
                            alt: "Priceline Icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontWeight: "bold",
                                textStyle: "captionBold",
                                color: "background.darkest",
                                children: titleText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                textStyle: "disclaimer",
                                color: "background.dark",
                                children: contentText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        ml: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            ml: "auto",
                            my: "auto",
                            pl: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                size: "small",
                                children: "Get"
                            })
                        })
                    })
                ]
            })
        ]
    }) : null;
}

;// CONCATENATED MODULE: ./src/components/AppBanner/index.tsx






function AppBannerWrapper(param) {
    var content = param.content;
    var showAppBanner = (0,useAppBanner/* default */.Z)();
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), referral = ref.referral, clientGUID = ref.webstats.clientGUID;
    return showAppBanner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBanner, (0,_object_spread/* default */.Z)({
        referral: referral !== null && referral !== void 0 ? referral : {},
        clientGUID: clientGUID !== null && clientGUID !== void 0 ? clientGUID : ""
    }, content)) : null;
}
/* harmony default export */ var components_AppBanner = (AppBannerWrapper);


/***/ }),

/***/ 7598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pcln_feature_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66252);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68464);
/* harmony import */ var _shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41811);





var getTrafficInfo = function(query, referral) {
    var tmp = referral.id, _ckReferralId = tmp === void 0 ? "" : tmp, tmp1 = referral.clickId, cookieRefClickId = tmp1 === void 0 ? "" : tmp1, tmp2 = referral.sourceId, _ckRefSourceId = tmp2 === void 0 ? "" : tmp2;
    var cookieRefId = _ckRefSourceId.concat(_ckReferralId);
    var tmp3 = query.refid, _qsRefId = tmp3 === void 0 ? "" : tmp3, tmp4 = query.refclickid, _qsRefClickId = tmp4 === void 0 ? "" : tmp4;
    var queryRefId = typeof _qsRefId === "string" && Object.keys(_qsRefId).length > 0 ? _qsRefId : "";
    var queryRefClickId = typeof _qsRefClickId === "string" && Object.keys(_qsRefClickId).length > 0 ? _qsRefClickId : "";
    var isPaid = cookieRefId.indexOf("GOOGLECPC|MSN") > -1 || queryRefId.indexOf("GOOGLECPC|MSN") > -1;
    var isBranded = cookieRefClickId.indexOf("BRAND") > -1 || queryRefClickId.indexOf("BRAND") > -1;
    var excludedRefIds = [
        "PLHTLCOMBINED",
        "PLHBC10161OPQ"
    ];
    var isBlackListed = cookieRefId.indexOf("CO") === 0 || queryRefId.indexOf("CO") === 0 || excludedRefIds.indexOf(cookieRefId) > -1 || excludedRefIds.indexOf(queryRefId) > -1;
    return {
        isPaid: isPaid,
        isBranded: isBranded,
        isBlackListed: isBlackListed
    };
};
var useAppBanner = function() {
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query;
    var bootstrapData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    var isCookieSetToHideAppBanner = bootstrapData.isCookieSetToHideAppBanner, _isMobile = bootstrapData.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, referral = bootstrapData.referral;
    var ref = getTrafficInfo(query, referral), isPaid = ref.isPaid, isBranded = ref.isBranded, isBlackListed = ref.isBlackListed;
    var isAppBannerEnabled = (0,_pcln_feature_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("siteExperience.appBannerEnabled");
    var hideAppBanner = !isAppBannerEnabled || isCookieSetToHideAppBanner || (0,_shared_utils_isLoadedInAppView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(query) || !isMobile || isPaid && !isBranded || isBlackListed;
    var showAppBanner = !hideAppBanner;
    return showAppBanner;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppBanner);


/***/ }),

/***/ 27204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jz": function() { return /* binding */ RENTAL_CAR_PRODUCT_TYPE; },
/* harmony export */   "Pz": function() { return /* binding */ BUNDLE_AND_SAVE_PRODUCT_TYPE; },
/* harmony export */   "Wn": function() { return /* binding */ HOME_PRODUCT_TYPE; },
/* harmony export */   "ZE": function() { return /* binding */ CRUISE_PRODUCT_TYPE; },
/* harmony export */   "kd": function() { return /* binding */ HOTEL_PRODUCT_TYPE; },
/* harmony export */   "nu": function() { return /* binding */ VACATION_PACKAGE_PRODUCT_TYPE; },
/* harmony export */   "oP": function() { return /* binding */ FLIGHT_PRODUCT_TYPE; }
/* harmony export */ });
/* unused harmony exports TRIPS_PRODUCT_TYPE, VACATIONS_PRODUCT_TYPE */
var CRUISE_PRODUCT_TYPE = "cruises";
var FLIGHT_PRODUCT_TYPE = "flights";
var HOME_PRODUCT_TYPE = "home";
var HOTEL_PRODUCT_TYPE = "hotels";
var RENTAL_CAR_PRODUCT_TYPE = "cars";
var TRIPS_PRODUCT_TYPE = "trips";
var VACATIONS_PRODUCT_TYPE = "vacations";
var VACATION_PACKAGE_PRODUCT_TYPE = "packages";
var BUNDLE_AND_SAVE_PRODUCT_TYPE = "bundle + save";


/***/ }),

/***/ 14602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulProvider/ContentfulProvider.js
var ContentfulProvider = __webpack_require__(26518);
// EXTERNAL MODULE: ./node_modules/@pcln/feature-components/dist/esm/FeatureProvider/FeatureProvider.js
var FeatureProvider = __webpack_require__(21643);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 11 modules
var Layout = __webpack_require__(78259);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
;// CONCATENATED MODULE: ./src/components/Home/index.tsx






var HomeDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(2803), __webpack_require__.e(1637), __webpack_require__.e(5617), __webpack_require__.e(7626), __webpack_require__.e(7996), __webpack_require__.e(7898), __webpack_require__.e(4231), __webpack_require__.e(6493), __webpack_require__.e(2638), __webpack_require__.e(370), __webpack_require__.e(2727), __webpack_require__.e(7055), __webpack_require__.e(9096), __webpack_require__.e(9725), __webpack_require__.e(9515), __webpack_require__.e(1946), __webpack_require__.e(6229), __webpack_require__.e(3990), __webpack_require__.e(3779), __webpack_require__.e(7154), __webpack_require__.e(3524), __webpack_require__.e(6622), __webpack_require__.e(5690)]).then(__webpack_require__.bind(__webpack_require__, 44091));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44091)
            ];
        }
    }
});
var HomeMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(2803), __webpack_require__.e(1637), __webpack_require__.e(5617), __webpack_require__.e(7626), __webpack_require__.e(7996), __webpack_require__.e(7898), __webpack_require__.e(4231), __webpack_require__.e(6493), __webpack_require__.e(2638), __webpack_require__.e(7055), __webpack_require__.e(9725), __webpack_require__.e(9515), __webpack_require__.e(1946), __webpack_require__.e(6229), __webpack_require__.e(3990), __webpack_require__.e(3779), __webpack_require__.e(7154), __webpack_require__.e(6622), __webpack_require__.e(5171)]).then(__webpack_require__.bind(__webpack_require__, 2992));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2992)
            ];
        }
    }
});
function Home() {
    (0,useSeti/* default */.Z)("AA_HOMEPAGE") // AA Test: Unconditional firing and no visual changes
    ;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDesktop, {})
    });
}

// EXTERNAL MODULE: ./src/components/AppBanner/constants.ts
var constants = __webpack_require__(71151);
// EXTERNAL MODULE: ./src/constants/products.ts
var products = __webpack_require__(27204);
// EXTERNAL MODULE: ./src/components/AppBanner/index.tsx + 2 modules
var AppBanner = __webpack_require__(93653);
// EXTERNAL MODULE: ./src/components/TmsScript/TmsScript.tsx + 2 modules
var TmsScript = __webpack_require__(38704);
;// CONCATENATED MODULE: ./src/pages/index.tsx











function Homepage(param) {
    var headerHTML = param.headerHTML, footerHTML = param.footerHTML, bootstrapData = param.bootstrapData, content = param.content;
    var pathname = (0,router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TmsScript/* default */.Z, {
                pathname: pathname
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureProvider/* default */.ZP, {
                features: bootstrapData.featureToggles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentfulProvider/* default */.Z, {
                    contentful: content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBanner["default"], {
                            content: constants/* default */.Z[products/* HOME_PRODUCT_TYPE */.Wn]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                            headerHTML: headerHTML,
                            footerHTML: footerHTML,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
                        })
                    ]
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pages = (Homepage);


/***/ }),

/***/ 41811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLoadedInAppView; }
/* harmony export */ });
function isLoadedInAppView(query) {
    var NEGOTIATORAPP = query.NEGOTIATORAPP, negotiatorapp = query.negotiatorapp;
    return NEGOTIATORAPP !== undefined || negotiatorapp !== undefined;
}


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 39997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75271);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14649);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var propTypes = {
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
};
var CloseButton = function (props) { return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, __assign({}, props, { icon: react__WEBPACK_IMPORTED_MODULE_0__.createElement(pcln_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { size: props.size }) }))); };
CloseButton.defaultProps = {
    size: 24,
    title: 'close',
};
CloseButton.propTypes = {};
CloseButton.displayName = 'CloseButton';
/* harmony default export */ __webpack_exports__["Z"] = (CloseButton);
//# sourceMappingURL=CloseButton.js.map

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2874,9263,1525,6945,5226,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);